import React from 'react';
import BoxButtonsWrapper from '../common/BoxButtonsWrapper';
import { PRIMARY_DARK } from '../../constants/constants';

// Palette d'éléments à glisser-déposer dans le document (BoxButtonsWrapper,
// inchangé depuis dev, cf. src/components/common/BoxButtonsWrapper.jsx) :
// inclut la section "Élément copié" (CopyItem) et les types de box
// disponibles (section, titres, texte, image, forme, variables...).
// dividerColor : les titres de section (GenerateDivider) sont en blanc par
// défaut (pensés pour le fond navy d'AdderMenu.jsx, seul autre consommateur),
// illisibles sur le fond blanc du panel de gauche.
const ElementsPanel = () => (
  <div style={{ padding: 16 }}>
    <BoxButtonsWrapper dividerColor={PRIMARY_DARK} showLabels />
  </div>
);

export default ElementsPanel;
